/** 訂單工作面 profile：同一 Orders／對帳頁，依入口收斂操作 */

export const ORDER_DESK_PROFILE = {
    FULL: 'full',
    FINANCE: 'finance',
    READONLY: 'readonly'
};

/**
 * @typedef {object} OrderDeskProfileConfig
 * @property {string} label
 * @property {boolean} allowStatusWrite
 * @property {boolean} allowShip
 * @property {boolean} allowComplete
 * @property {boolean} allowRefund
 * @property {boolean} allowCancel
 * @property {boolean} showFinanceExport
 */

/** @type {Record<string, OrderDeskProfileConfig>} */
export const ORDER_DESK_PROFILE_CONFIG = {
    [ORDER_DESK_PROFILE.FULL]: {
        label: '完整',
        allowStatusWrite: true,
        allowShip: true,
        allowComplete: true,
        allowRefund: true,
        allowCancel: true,
        showFinanceExport: true
    },
    [ORDER_DESK_PROFILE.FINANCE]: {
        label: '財務',
        allowStatusWrite: true,
        allowShip: false,
        allowComplete: true,
        allowRefund: true,
        allowCancel: true,
        showFinanceExport: true
    },
    [ORDER_DESK_PROFILE.READONLY]: {
        label: '唯讀',
        allowStatusWrite: false,
        allowShip: false,
        allowComplete: false,
        allowRefund: false,
        allowCancel: false,
        showFinanceExport: false
    }
};

export function getOrderDeskProfileFromRouteMeta(meta) {
    const profile = meta?.orderDeskProfile;
    if (profile && ORDER_DESK_PROFILE_CONFIG[profile]) {
        return profile;
    }
    return ORDER_DESK_PROFILE.FULL;
}

export function resolveOrderDeskActionAllowed(profile, actionKey, hasPermission) {
    const cfg =
        ORDER_DESK_PROFILE_CONFIG[profile] ||
        ORDER_DESK_PROFILE_CONFIG[ORDER_DESK_PROFILE.FULL];
    if (!hasPermission) return false;
    switch (actionKey) {
        case 'status':
            return cfg.allowStatusWrite;
        case 'ship':
            return cfg.allowShip;
        case 'complete':
            return cfg.allowComplete;
        case 'refund':
            return cfg.allowRefund;
        case 'cancel':
            return cfg.allowCancel;
        case 'financeExport':
            return cfg.showFinanceExport;
        default:
            return hasPermission;
    }
}
